import React from "react";
import { Box, Typography } from "@mui/material";

const MenuTableCellBadge = ({
  prefixAdornment,
  suffixAdornment,
  displayValue,
  valueAmount, // Raw numeric value in cents for conditional coloring
  useConditionalColor = false, // Flag to enable conditional coloring
}) => {
    const displayFormatted = displayValue === null ? '-' : `${prefixAdornment || ""}${displayValue}${suffixAdornment || ""}`

  // Determine colors based on value
  const getColors = () => {
    if (!useConditionalColor || valueAmount === null || valueAmount === undefined) {
      return {
        backgroundColor: (theme) => theme.palette.terrain[100],
        color: (theme) => theme.palette.terrain[900],
      };
    }

    if (valueAmount > 0) {
      return {
        backgroundColor: (theme) => theme.palette.success[50],
        color: (theme) => theme.palette.success[700],
      };
    } else if (valueAmount < 0) {
      return {
        backgroundColor: (theme) => theme.palette.error[50],
        color: (theme) => theme.palette.error[900],
      };
    } else {
      return {
        backgroundColor: (theme) => theme.palette.terrain[100],
        color: (theme) => theme.palette.terrain[900],
      };
    }
  };

  const colors = getColors();

  return (
    <Box
      sx={{
        height: "24px",
        backgroundColor: colors.backgroundColor,
        borderRadius: 1,
        padding: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content",
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: colors.color,
          fontWeight: 400,
        }}
      >
        {displayFormatted}
      </Typography>
    </Box>
  );
};

export default MenuTableCellBadge;
